import { render, staticRenderFns } from "./CorCarryStatus.vue?vue&type=template&id=5902a59f&"
import script from "./CorCarryStatus.vue?vue&type=script&lang=js&"
export * from "./CorCarryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports